// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath d=%27m5.8 3.6 .4.4.4-.4m0 4.8-.4-.4-.4.4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-Optimized Form Controls */

/* Form Controls - Larger touch targets on mobile */
.form-control,
.form-select {
  min-height: var(--touch-target-min);
  font-size: var(--font-size-base);
  padding: var(--spacing-sm) var(--spacing-md);
}

/* Full-width inputs on mobile */
@media (max-width: 767.98px) {
  .form-control,
  .form-select {
    width: 100%;
  }

  /* Better spacing between form groups */
  .form-group,
  .mb-3 {
    margin-bottom: var(--spacing-lg) !important;
  }
}

/* Checkbox and Radio - Larger touch targets */
.form-check-input {
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0.125rem;
}

@media (max-width: 767.98px) {
  .form-check-input {
    width: 1.5rem;
    height: 1.5rem;
    margin-top: 0.25rem;
  }

  .form-check-label {
    font-size: var(--font-size-base);
    padding-left: var(--spacing-sm);
  }
}

/* Form Labels - Better readability on mobile */
.form-label {
  font-size: var(--font-size-base);
  font-weight: 500;
  margin-bottom: var(--spacing-xs);
  color: var(--text-primary);
}

@media (max-width: 767.98px) {
  .form-label {
    font-size: var(--font-size-base);
    margin-bottom: var(--spacing-sm);
  }
}

/* Input Groups - Better mobile layout */
.input-group {
  margin-bottom: var(--spacing-md);
}

@media (max-width: 767.98px) {
  .input-group {
    flex-direction: column;
  }

  .input-group .form-control,
  .input-group .form-select {
    border-radius: var(--border-radius-md);
    margin-bottom: var(--spacing-sm);
  }

  .input-group .btn {
    border-radius: var(--border-radius-md);
    width: 100%;
  }
}

/* Buttons in forms - Full width on mobile */
@media (max-width: 767.98px) {
  .modal-footer .btn,
  .form-actions .btn {
    width: 100%;
    margin-bottom: var(--spacing-sm);
  }

  .modal-footer .btn:last-child,
  .form-actions .btn:last-child {
    margin-bottom: 0;
  }
}

/* Date/Time pickers - Mobile optimization */
input[type="date"],
input[type="time"],
input[type="datetime-local"] {
  min-height: var(--touch-target-min);
  font-size: var(--font-size-base);
}

/* Select dropdowns - Better mobile experience */
.form-select {
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}

@media (max-width: 767.98px) {
  .form-select {
    font-size: var(--font-size-base);
    padding: var(--spacing-sm) var(--spacing-md);
    padding-right: 3rem;
  }
}

/* Form validation - Better mobile display */
.form-control.is-invalid,
.form-select.is-invalid {
  border-color: var(--color-danger);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invalid-feedback {
  display: block;
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-xs);
}

/* Form sections - Better spacing on mobile */
.form-section {
  margin-bottom: var(--spacing-xl);
}

@media (max-width: 767.98px) {
  .form-section {
    margin-bottom: var(--spacing-lg);
  }
}

/* Filter sections - Collapsible on mobile */
@media (max-width: 767.98px) {
  .filter-section {
    margin-bottom: var(--spacing-md);
  }

  .filter-section .form-row,
  .filter-section .row {
    margin-bottom: var(--spacing-sm);
  }

  .filter-section .form-group {
    margin-bottom: var(--spacing-md);
  }
}

/* Switch styling - Using Bootstrap's native form-switch */
.rating-mode-label {
  flex-shrink: 0;
}

.rating-mode-switch {
  flex-shrink: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}

/* Ensure consistent switch width across all devices */
.rating-mode-switch.form-switch .form-check-input {
  width: 3rem;
  min-width: 3rem;
  height: 1.5rem;
  flex-shrink: 0;
  margin-top: 0;
  margin-right: 0.75rem;
}

.rating-mode-switch .form-check-label {
  font-size: var(--font-size-sm);
  line-height: 1.5;
  margin-left: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

`, "",{"version":3,"sources":["webpack://./src/styles/forms.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,mDAAmD;AACnD;;EAEE,mCAAmC;EACnC,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;EACE;;IAEE,WAAW;EACb;;EAEA,uCAAuC;EACvC;;IAEE,2CAA2C;EAC7C;AACF;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;AACF;;AAEA,+CAA+C;AAC/C;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE;IACE,gCAAgC;IAChC,gCAAgC;EAClC;AACF;;AAEA,wCAAwC;AACxC;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,sCAAsC;IACtC,gCAAgC;EAClC;;EAEA;IACE,sCAAsC;IACtC,WAAW;EACb;AACF;;AAEA,4CAA4C;AAC5C;EACE;;IAEE,WAAW;IACX,gCAAgC;EAClC;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,4CAA4C;AAC5C;;;EAGE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE;IACE,gCAAgC;IAChC,4CAA4C;IAC5C,mBAAmB;EACrB;AACF;;AAEA,4CAA4C;AAC5C;;EAEE,iCAAiC;EACjC,oCAAoC;EACpC,yDAAkQ;EAClQ,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,6CAA6C;AAC7C;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,gCAAgC;EAClC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA,0DAA0D;AAC1D;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* Mobile-Optimized Form Controls */\n\n/* Form Controls - Larger touch targets on mobile */\n.form-control,\n.form-select {\n  min-height: var(--touch-target-min);\n  font-size: var(--font-size-base);\n  padding: var(--spacing-sm) var(--spacing-md);\n}\n\n/* Full-width inputs on mobile */\n@media (max-width: 767.98px) {\n  .form-control,\n  .form-select {\n    width: 100%;\n  }\n\n  /* Better spacing between form groups */\n  .form-group,\n  .mb-3 {\n    margin-bottom: var(--spacing-lg) !important;\n  }\n}\n\n/* Checkbox and Radio - Larger touch targets */\n.form-check-input {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-top: 0.125rem;\n}\n\n@media (max-width: 767.98px) {\n  .form-check-input {\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-top: 0.25rem;\n  }\n\n  .form-check-label {\n    font-size: var(--font-size-base);\n    padding-left: var(--spacing-sm);\n  }\n}\n\n/* Form Labels - Better readability on mobile */\n.form-label {\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  margin-bottom: var(--spacing-xs);\n  color: var(--text-primary);\n}\n\n@media (max-width: 767.98px) {\n  .form-label {\n    font-size: var(--font-size-base);\n    margin-bottom: var(--spacing-sm);\n  }\n}\n\n/* Input Groups - Better mobile layout */\n.input-group {\n  margin-bottom: var(--spacing-md);\n}\n\n@media (max-width: 767.98px) {\n  .input-group {\n    flex-direction: column;\n  }\n\n  .input-group .form-control,\n  .input-group .form-select {\n    border-radius: var(--border-radius-md);\n    margin-bottom: var(--spacing-sm);\n  }\n\n  .input-group .btn {\n    border-radius: var(--border-radius-md);\n    width: 100%;\n  }\n}\n\n/* Buttons in forms - Full width on mobile */\n@media (max-width: 767.98px) {\n  .modal-footer .btn,\n  .form-actions .btn {\n    width: 100%;\n    margin-bottom: var(--spacing-sm);\n  }\n\n  .modal-footer .btn:last-child,\n  .form-actions .btn:last-child {\n    margin-bottom: 0;\n  }\n}\n\n/* Date/Time pickers - Mobile optimization */\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"] {\n  min-height: var(--touch-target-min);\n  font-size: var(--font-size-base);\n}\n\n/* Select dropdowns - Better mobile experience */\n.form-select {\n  background-size: 1.5rem 1.5rem;\n  padding-right: 2.5rem;\n}\n\n@media (max-width: 767.98px) {\n  .form-select {\n    font-size: var(--font-size-base);\n    padding: var(--spacing-sm) var(--spacing-md);\n    padding-right: 3rem;\n  }\n}\n\n/* Form validation - Better mobile display */\n.form-control.is-invalid,\n.form-select.is-invalid {\n  border-color: var(--color-danger);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath d='m5.8 3.6 .4.4.4-.4m0 4.8-.4-.4-.4.4'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.invalid-feedback {\n  display: block;\n  font-size: var(--font-size-sm);\n  margin-top: var(--spacing-xs);\n}\n\n/* Form sections - Better spacing on mobile */\n.form-section {\n  margin-bottom: var(--spacing-xl);\n}\n\n@media (max-width: 767.98px) {\n  .form-section {\n    margin-bottom: var(--spacing-lg);\n  }\n}\n\n/* Filter sections - Collapsible on mobile */\n@media (max-width: 767.98px) {\n  .filter-section {\n    margin-bottom: var(--spacing-md);\n  }\n\n  .filter-section .form-row,\n  .filter-section .row {\n    margin-bottom: var(--spacing-sm);\n  }\n\n  .filter-section .form-group {\n    margin-bottom: var(--spacing-md);\n  }\n}\n\n/* Switch styling - Using Bootstrap's native form-switch */\n.rating-mode-label {\n  flex-shrink: 0;\n}\n\n.rating-mode-switch {\n  flex-shrink: 0;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* Ensure consistent switch width across all devices */\n.rating-mode-switch.form-switch .form-check-input {\n  width: 3rem;\n  min-width: 3rem;\n  height: 1.5rem;\n  flex-shrink: 0;\n  margin-top: 0;\n  margin-right: 0.75rem;\n}\n\n.rating-mode-switch .form-check-label {\n  font-size: var(--font-size-sm);\n  line-height: 1.5;\n  margin-left: 0;\n  margin-bottom: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
